import { ObservableQuery } from '@apollo/client';
import { FindAllProjectMembersResponse } from '@ih/app/shared/apis/interfaces';

export class FindAllProjectsSuccess {
  public static readonly type = '[User/Projects] FindAllProjectsSuccess';
  constructor(
    public readonly result: ObservableQuery.Result<{
      findAllProjectsForUser: FindAllProjectMembersResponse;
    }>,
  ) {}
}
